import { useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

import type { Pin } from "models";

export const useAddPinMutation = () =>
  useTypedMutation({
    mutationFn: async (payload: Pin) => (await ApiInstance.post("/pins/append", payload)).data,
    onSuccess: () => null
  });
